import { ThemeProvider } from "@material-ui/core";
import { SnackbarProvider } from "notistack";
import React from "react";
import { Provider } from "react-redux";
import "./App.css";
import { TermsModal } from "./components/Terms/TermsModal";
import store from "./store";
import theme from "./theme";
import WalletWrapper from "./WalletWrapper";

const App = () => {
  const [isTermsPopupOpen, setIsTermsPopupOpen] = React.useState(false);

  React.useEffect(() => {
    const disclaimerVersion = "disclaimer_version_1";
    const isDisclaimerAccepted = localStorage.getItem(disclaimerVersion);
    if (!isDisclaimerAccepted) {
      setIsTermsPopupOpen(true);
    }
  }, []);

  const handleDisclaimerClose = (props, reason) => {
    if (reason === "backdropClick") return;
    const disclaimerVersion = "disclaimer_version_1";
    localStorage.setItem(disclaimerVersion, "accepted");
    setIsTermsPopupOpen(false);
  };

  return (
    <div className="App">
      <Provider store={store}>
        <SnackbarProvider>
          <ThemeProvider theme={theme}>
            <TermsModal
              open={isTermsPopupOpen}
              handleClose={handleDisclaimerClose}
            />
            <WalletWrapper />
          </ThemeProvider>
        </SnackbarProvider>
      </Provider>
    </div>
  );
};

export default App;
